var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.reportType=='Concussion')?_c('cmpConcussion',{attrs:{"motionDataId":_vm.motionDataId,"chartObj":_vm.chartObj,"features":_vm.features}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }